import React, { useEffect, useState } from 'react'
import { LinkListProps } from './types/LinkList.types'
import { Link, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react'
import { windowService } from '../../utils/window.utils'
import './index.scss'
import { anchorWithId } from '../../helpers/anchorWithId.helper'

const LinkList = (props: LinkListProps) => {
  const filterLabels = props.fields?.List
  const [currentUrl, setCurrentUrl] = useState<string>('')

  useEffect(() => {
    setCurrentUrl(
      '/' +
        props.sitecoreContext?.language +
        windowService()?.location?.href?.split(props.sitecoreContext?.language)[1]
    )
  }, [])

  return (
    <>
      <div id={props?.rendering?.uid}>
        {props.fields && (
          <div className="linklist-wrapper">
            <div className="filternav__bar linklist-bar">
              <div>
                <div>
                  {filterLabels &&
                    filterLabels.length > 0 &&
                    filterLabels.map((navItem, index) => {
                      const isActive =
                        navItem.fields?.Link?.value?.linktype === 'internal' &&
                        currentUrl === navItem.fields?.Link?.value?.href

                      return (
                        <span key={index} className={'filternav__bar__label'}>
                          <Link
                            field={{
                              ...navItem.fields?.Link
                            }}
                          />
                          <div
                            className={
                              isActive
                                ? 'filternav__bar__label__active'
                                : 'filternav__bar__label__hover'
                            }
                          />
                        </span>
                      )
                    })}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default withSitecoreContext()(LinkList)
